import React from 'react'

import SideModalFiltersWrapper from '../../../../components/filter/SideModalFiltersWrapper'
import ActivatedFilter from '../../../../components/filter/ActivatedFilter'

const FilterModal = ({ open, onClose }) => {
  return (
    <SideModalFiltersWrapper open={open} onClose={onClose}>
      <ActivatedFilter presentation="list" />
    </SideModalFiltersWrapper>
  )
}

export default FilterModal
